$.fn.PostShare = function() {
  let self = this

  return function() {
    self.find('.post-share__button').on('click', function() {
      if (self.attr('aria-expanded') && self.attr('aria-expanded') == 'false') {
        self.attr('aria-expanded', 'true')
      } else if (self.attr('aria-expanded') && self.attr('aria-expanded') == 'true') {
        self.attr('aria-expanded', 'false')
      }
    })
    return self
  }()
}
